// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

const e = {
  production: true, // Set to true before the production build and deployment
  serverUrl: '',
  rootUrl: '',
  loginUrl: '/login',
  assets: '../../../assets',
  wsEndpoint: '',
  wsReconnectInterval: 2000,
  refreshInterval: 60000,
  stage: 'maudev',
  apiServiceId: 'umjzdeh2qf',
  accessKeyId: 'AKIAVRUVPHSPEUMIQ4MD',
  secretAccessKey: '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',
  column_name: 'Subclass Id',
  custom_field: 'subclass_id',
  prod_labels: ['Group', 'Department', 'Class', 'Subclass'],
  bourneUrl: 'https://d1cfgiy588ai99.cloudfront.net/?embedded=true',
  region: 'us-east-1',
  cognito: {
    userPoolId: 'us-east-1_IiDcjdQRi',
    userPoolClientId: 'mn7k631huh54dumq1kps98lqq',
    oauthDomain: 'sizeo-maudev.auth.us-east-1.amazoncognito.com',
    redirectSignIn: [
      'http://localhost:4200/',
      'https://d1jxpyi545vya8.cloudfront.net/',
      'https://mau-dev.sizeo.ai/'
    ],
    redirectSignOut: [
      'http://localhost:4200/logout/',
      'https://d1jxpyi545vya8.cloudfront.net/logout/',
      'https://mau-dev.sizeo.ai/logout/'
    ]
  },
  appsync: {
    endpoint: 'https://anvg2zs6kvghlkc3pwxgj7hkui.appsync-api.us-east-1.amazonaws.com/graphql'
  }
}

export const environment = e

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
